import Link from "next/link";
import Typography from "@mui/material/Typography";

import { BaseButton } from "@/src/component/base/BaseButton";

import styles from "./Missing404.module.scss";

function Missing404() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Typography variant="h2">404</Typography>
        <Typography variant="body1">Oops! Looks like you are a little lost.</Typography>
        <Link href={"/"}>
          <BaseButton variant="contained">Return Home</BaseButton>
        </Link>
      </div>
    </div>
  );
}

export default Missing404;
